import React from 'react'
import StaffList from '../staff_components/staff_list'

export default function StaffListPage() {
  return (
    <div className="content-wrapper" style={{ marginLeft: 0 }}>
      <StaffList />
    </div>
  )
}
